module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMTYgMjAiIHdpZHRoPSIxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im02NjggNDAydjE5LjU2MjVsMTUuNzEwOTM4LTkuMjgxMjV6IiBmaWxsPSIjZDYwYzhjIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02NjggLTQwMikiLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ../core/src/assets/images/global-play.svg
// module id = 466
// module chunks = 0